/*
 * Project: Goalscape
 * File:    index.js
 * Path:    src/index.js
 * Description: Entry point of the application; renders the App component.
 * Author:  Akmal Djumakhodjaev
 * Created: [Creation Date - YYYY-MM-DD]
 * Modified: 2025-03-15
 * AI Hint: Consider implementing error boundaries to catch and handle rendering errors gracefully.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import 'react-datepicker/dist/react-datepicker.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode> // NOTE: disable strict mode to fix drag'n'drop bugs with dnd library
    <App />
  // </React.StrictMode>
);